import { ParallaxLayer } from '@react-spring/parallax'
import React from 'react'
import ScrollComponents from '../../../widgets/scrollComponents'
import { predeterminedContacts } from './predeterminedConstants'
import './style.scss'

const fadeRightInAnimation = {
  loop: false,
  from: { opacity: 0, fontSize: 0 },
  to: { opacity: 1, fontSize: 75 },
  config: {
    duration: 500,
  },
  delay: 100,
}

function HomeMyContacts() {

  return (
    <ParallaxLayer offset={6} className={'my-contacts-container'}>
      <div className={'my-contacts'}>
        <div>
          <ScrollComponents springConfig={fadeRightInAnimation} className={'my-contacts-title'}>
            <b>Interact</b> With Me!
          </ScrollComponents>
          { predeterminedContacts.map((contact) => (
            <a href={contact.url} target='_blank' rel='noreferrer'>
              { contact.icon }
            </a>
          ))}
        </div>
      </div>
    </ParallaxLayer>
  )
}

export default HomeMyContacts
